/**
 * Do not edit directly
 * Generated on Thu, 30 May 2024 08:13:03 GMT
 */

module.exports = {
  "base": {
    "color": {
      "scale": {
        "black": {
          "0": {
            "value": "#1f2328",
            "dark": "#010409",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#1f2328",
              "dark": "#010409"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "black",
              "0"
            ]
          }
        },
        "transparent": {
          "value": "#ffffff00",
          "dark": "#00000000",
          "filePath": "tokens/base/colors/light.json",
          "isSource": true,
          "original": {
            "value": "#ffffff00",
            "dark": "#00000000"
          },
          "name": "transparent",
          "attributes": {},
          "path": [
            "base",
            "color",
            "scale",
            "transparent"
          ]
        },
        "white": {
          "0": {
            "value": "#ffffff",
            "dark": "#ffffff",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#ffffff",
              "dark": "#ffffff"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "white",
              "0"
            ]
          }
        },
        "gray": {
          "0": {
            "value": "#f6f8fa",
            "dark": "#f0f6fc",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#f6f8fa",
              "dark": "#f0f6fc"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "gray",
              "0"
            ]
          },
          "1": {
            "value": "#eaeef2",
            "dark": "#c9d1d9",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#eaeef2",
              "dark": "#c9d1d9"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "gray",
              "1"
            ]
          },
          "2": {
            "value": "#d0d7de",
            "dark": "#b1bac4",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#d0d7de",
              "dark": "#b1bac4"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "gray",
              "2"
            ]
          },
          "3": {
            "value": "#afb8c1",
            "dark": "#8b949e",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#afb8c1",
              "dark": "#8b949e"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "gray",
              "3"
            ]
          },
          "4": {
            "value": "#8c959f",
            "dark": "#6e7681",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#8c959f",
              "dark": "#6e7681"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "gray",
              "4"
            ]
          },
          "5": {
            "value": "#6e7781",
            "dark": "#484f58",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#6e7781",
              "dark": "#484f58"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "gray",
              "5"
            ]
          },
          "6": {
            "value": "#57606a",
            "dark": "#30363d",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#57606a",
              "dark": "#30363d"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "gray",
              "6"
            ]
          },
          "7": {
            "value": "#424a53",
            "dark": "#21262d",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#424a53",
              "dark": "#21262d"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "gray",
              "7"
            ]
          },
          "8": {
            "value": "#32383f",
            "dark": "#161b22",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#32383f",
              "dark": "#161b22"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "gray",
              "8"
            ]
          },
          "9": {
            "value": "#24292f",
            "dark": "#0d1117",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#24292f",
              "dark": "#0d1117"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "gray",
              "9"
            ]
          }
        },
        "blue": {
          "0": {
            "value": "#ddf4ff",
            "dark": "#cae8ff",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#ddf4ff",
              "dark": "#cae8ff"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "blue",
              "0"
            ]
          },
          "1": {
            "value": "#b6e3ff",
            "dark": "#a5d6ff",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#b6e3ff",
              "dark": "#a5d6ff"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "blue",
              "1"
            ]
          },
          "2": {
            "value": "#80ccff",
            "dark": "#79c0ff",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#80ccff",
              "dark": "#79c0ff"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "blue",
              "2"
            ]
          },
          "3": {
            "value": "#54aeff",
            "dark": "#58a6ff",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#54aeff",
              "dark": "#58a6ff"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "blue",
              "3"
            ]
          },
          "4": {
            "value": "#218bff",
            "dark": "#388bfd",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#218bff",
              "dark": "#388bfd"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "blue",
              "4"
            ]
          },
          "5": {
            "value": "#0969da",
            "dark": "#1f6feb",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#0969da",
              "dark": "#1f6feb"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "blue",
              "5"
            ]
          },
          "6": {
            "value": "#0550ae",
            "dark": "#1158c7",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#0550ae",
              "dark": "#1158c7"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "blue",
              "6"
            ]
          },
          "7": {
            "value": "#033d8b",
            "dark": "#0d419d",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#033d8b",
              "dark": "#0d419d"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "blue",
              "7"
            ]
          },
          "8": {
            "value": "#0a3069",
            "dark": "#0c2d6b",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#0a3069",
              "dark": "#0c2d6b"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "blue",
              "8"
            ]
          },
          "9": {
            "value": "#002155",
            "dark": "#051d4d",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#002155",
              "dark": "#051d4d"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "blue",
              "9"
            ]
          }
        },
        "green": {
          "0": {
            "value": "#dafbe1",
            "dark": "#aff5b4",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#dafbe1",
              "dark": "#aff5b4"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "green",
              "0"
            ]
          },
          "1": {
            "value": "#aceebb",
            "dark": "#7ee787",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#aceebb",
              "dark": "#7ee787"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "green",
              "1"
            ]
          },
          "2": {
            "value": "#6fdd8b",
            "dark": "#56d364",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#6fdd8b",
              "dark": "#56d364"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "green",
              "2"
            ]
          },
          "3": {
            "value": "#4ac26b",
            "dark": "#3fb950",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#4ac26b",
              "dark": "#3fb950"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "green",
              "3"
            ]
          },
          "4": {
            "value": "#2da44e",
            "dark": "#2ea043",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#2da44e",
              "dark": "#2ea043"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "green",
              "4"
            ]
          },
          "5": {
            "value": "#1a7f37",
            "dark": "#238636",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#1a7f37",
              "dark": "#238636"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "green",
              "5"
            ]
          },
          "6": {
            "value": "#116329",
            "dark": "#196c2e",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#116329",
              "dark": "#196c2e"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "green",
              "6"
            ]
          },
          "7": {
            "value": "#044f1e",
            "dark": "#0f5323",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#044f1e",
              "dark": "#0f5323"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "green",
              "7"
            ]
          },
          "8": {
            "value": "#003d16",
            "dark": "#033a16",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#003d16",
              "dark": "#033a16"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "green",
              "8"
            ]
          },
          "9": {
            "value": "#002d11",
            "dark": "#04260f",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#002d11",
              "dark": "#04260f"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "green",
              "9"
            ]
          }
        },
        "yellow": {
          "0": {
            "value": "#fff8c5",
            "dark": "#f8e3a1",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#fff8c5",
              "dark": "#f8e3a1"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "yellow",
              "0"
            ]
          },
          "1": {
            "value": "#fae17d",
            "dark": "#f2cc60",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#fae17d",
              "dark": "#f2cc60"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "yellow",
              "1"
            ]
          },
          "2": {
            "value": "#eac54f",
            "dark": "#e3b341",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#eac54f",
              "dark": "#e3b341"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "yellow",
              "2"
            ]
          },
          "3": {
            "value": "#d4a72c",
            "dark": "#d29922",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#d4a72c",
              "dark": "#d29922"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "yellow",
              "3"
            ]
          },
          "4": {
            "value": "#bf8700",
            "dark": "#bb8009",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#bf8700",
              "dark": "#bb8009"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "yellow",
              "4"
            ]
          },
          "5": {
            "value": "#9a6700",
            "dark": "#9e6a03",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#9a6700",
              "dark": "#9e6a03"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "yellow",
              "5"
            ]
          },
          "6": {
            "value": "#7d4e00",
            "dark": "#845306",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#7d4e00",
              "dark": "#845306"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "yellow",
              "6"
            ]
          },
          "7": {
            "value": "#633c01",
            "dark": "#693e00",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#633c01",
              "dark": "#693e00"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "yellow",
              "7"
            ]
          },
          "8": {
            "value": "#4d2d00",
            "dark": "#4b2900",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#4d2d00",
              "dark": "#4b2900"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "yellow",
              "8"
            ]
          },
          "9": {
            "value": "#3b2300",
            "dark": "#341a00",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#3b2300",
              "dark": "#341a00"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "yellow",
              "9"
            ]
          }
        },
        "orange": {
          "0": {
            "value": "#fff1e5",
            "dark": "#ffdfb6",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#fff1e5",
              "dark": "#ffdfb6"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "orange",
              "0"
            ]
          },
          "1": {
            "value": "#ffd8b5",
            "dark": "#ffc680",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#ffd8b5",
              "dark": "#ffc680"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "orange",
              "1"
            ]
          },
          "2": {
            "value": "#ffb77c",
            "dark": "#ffa657",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#ffb77c",
              "dark": "#ffa657"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "orange",
              "2"
            ]
          },
          "3": {
            "value": "#fb8f44",
            "dark": "#f0883e",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#fb8f44",
              "dark": "#f0883e"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "orange",
              "3"
            ]
          },
          "4": {
            "value": "#e16f24",
            "dark": "#db6d28",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#e16f24",
              "dark": "#db6d28"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "orange",
              "4"
            ]
          },
          "5": {
            "value": "#bc4c00",
            "dark": "#bd561d",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#bc4c00",
              "dark": "#bd561d"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "orange",
              "5"
            ]
          },
          "6": {
            "value": "#953800",
            "dark": "#9b4215",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#953800",
              "dark": "#9b4215"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "orange",
              "6"
            ]
          },
          "7": {
            "value": "#762c00",
            "dark": "#762d0a",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#762c00",
              "dark": "#762d0a"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "orange",
              "7"
            ]
          },
          "8": {
            "value": "#5c2200",
            "dark": "#5a1e02",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#5c2200",
              "dark": "#5a1e02"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "orange",
              "8"
            ]
          },
          "9": {
            "value": "#471700",
            "dark": "#3d1300",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#471700",
              "dark": "#3d1300"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "orange",
              "9"
            ]
          }
        },
        "red": {
          "0": {
            "value": "#ffebe9",
            "dark": "#ffdcd7",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#ffebe9",
              "dark": "#ffdcd7"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "red",
              "0"
            ]
          },
          "1": {
            "value": "#ffcecb",
            "dark": "#ffc1ba",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#ffcecb",
              "dark": "#ffc1ba"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "red",
              "1"
            ]
          },
          "2": {
            "value": "#ffaba8",
            "dark": "#ffa198",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#ffaba8",
              "dark": "#ffa198"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "red",
              "2"
            ]
          },
          "3": {
            "value": "#ff8182",
            "dark": "#ff7b72",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#ff8182",
              "dark": "#ff7b72"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "red",
              "3"
            ]
          },
          "4": {
            "value": "#fa4549",
            "dark": "#f85149",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#fa4549",
              "dark": "#f85149"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "red",
              "4"
            ]
          },
          "5": {
            "value": "#cf222e",
            "dark": "#da3633",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#cf222e",
              "dark": "#da3633"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "red",
              "5"
            ]
          },
          "6": {
            "value": "#a40e26",
            "dark": "#b62324",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#a40e26",
              "dark": "#b62324"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "red",
              "6"
            ]
          },
          "7": {
            "value": "#82071e",
            "dark": "#8e1519",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#82071e",
              "dark": "#8e1519"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "red",
              "7"
            ]
          },
          "8": {
            "value": "#660018",
            "dark": "#67060c",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#660018",
              "dark": "#67060c"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "red",
              "8"
            ]
          },
          "9": {
            "value": "#4c0014",
            "dark": "#490202",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#4c0014",
              "dark": "#490202"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "red",
              "9"
            ]
          }
        },
        "purple": {
          "0": {
            "value": "#fbefff",
            "dark": "#eddeff",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#fbefff",
              "dark": "#eddeff"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "purple",
              "0"
            ]
          },
          "1": {
            "value": "#ecd8ff",
            "dark": "#e2c5ff",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#ecd8ff",
              "dark": "#e2c5ff"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "purple",
              "1"
            ]
          },
          "2": {
            "value": "#d8b9ff",
            "dark": "#d2a8ff",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#d8b9ff",
              "dark": "#d2a8ff"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "purple",
              "2"
            ]
          },
          "3": {
            "value": "#c297ff",
            "dark": "#bc8cff",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#c297ff",
              "dark": "#bc8cff"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "purple",
              "3"
            ]
          },
          "4": {
            "value": "#a475f9",
            "dark": "#a371f7",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#a475f9",
              "dark": "#a371f7"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "purple",
              "4"
            ]
          },
          "5": {
            "value": "#8250df",
            "dark": "#8957e5",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#8250df",
              "dark": "#8957e5"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "purple",
              "5"
            ]
          },
          "6": {
            "value": "#6639ba",
            "dark": "#6e40c9",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#6639ba",
              "dark": "#6e40c9"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "purple",
              "6"
            ]
          },
          "7": {
            "value": "#512a97",
            "dark": "#553098",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#512a97",
              "dark": "#553098"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "purple",
              "7"
            ]
          },
          "8": {
            "value": "#3e1f79",
            "dark": "#3c1e70",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#3e1f79",
              "dark": "#3c1e70"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "purple",
              "8"
            ]
          },
          "9": {
            "value": "#2e1461",
            "dark": "#271052",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#2e1461",
              "dark": "#271052"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "purple",
              "9"
            ]
          }
        },
        "pink": {
          "0": {
            "value": "#ffeff7",
            "dark": "#ffdaec",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#ffeff7",
              "dark": "#ffdaec"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "pink",
              "0"
            ]
          },
          "1": {
            "value": "#ffd3eb",
            "dark": "#ffbedd",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#ffd3eb",
              "dark": "#ffbedd"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "pink",
              "1"
            ]
          },
          "2": {
            "value": "#ffadda",
            "dark": "#ff9bce",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#ffadda",
              "dark": "#ff9bce"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "pink",
              "2"
            ]
          },
          "3": {
            "value": "#ff80c8",
            "dark": "#f778ba",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#ff80c8",
              "dark": "#f778ba"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "pink",
              "3"
            ]
          },
          "4": {
            "value": "#e85aad",
            "dark": "#db61a2",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#e85aad",
              "dark": "#db61a2"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "pink",
              "4"
            ]
          },
          "5": {
            "value": "#bf3989",
            "dark": "#bf4b8a",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#bf3989",
              "dark": "#bf4b8a"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "pink",
              "5"
            ]
          },
          "6": {
            "value": "#99286e",
            "dark": "#9e3670",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#99286e",
              "dark": "#9e3670"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "pink",
              "6"
            ]
          },
          "7": {
            "value": "#772057",
            "dark": "#7d2457",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#772057",
              "dark": "#7d2457"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "pink",
              "7"
            ]
          },
          "8": {
            "value": "#611347",
            "dark": "#5e103e",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#611347",
              "dark": "#5e103e"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "pink",
              "8"
            ]
          },
          "9": {
            "value": "#4d0336",
            "dark": "#42062a",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#4d0336",
              "dark": "#42062a"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "pink",
              "9"
            ]
          }
        },
        "coral": {
          "0": {
            "value": "#fff0eb",
            "dark": "#ffddd2",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#fff0eb",
              "dark": "#ffddd2"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "coral",
              "0"
            ]
          },
          "1": {
            "value": "#ffd6cc",
            "dark": "#ffc2b2",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#ffd6cc",
              "dark": "#ffc2b2"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "coral",
              "1"
            ]
          },
          "2": {
            "value": "#ffb4a1",
            "dark": "#ffa28b",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#ffb4a1",
              "dark": "#ffa28b"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "coral",
              "2"
            ]
          },
          "3": {
            "value": "#fd8c73",
            "dark": "#f78166",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#fd8c73",
              "dark": "#f78166"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "coral",
              "3"
            ]
          },
          "4": {
            "value": "#ec6547",
            "dark": "#ea6045",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#ec6547",
              "dark": "#ea6045"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "coral",
              "4"
            ]
          },
          "5": {
            "value": "#c4432b",
            "dark": "#cf462d",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#c4432b",
              "dark": "#cf462d"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "coral",
              "5"
            ]
          },
          "6": {
            "value": "#9e2f1c",
            "dark": "#ac3220",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#9e2f1c",
              "dark": "#ac3220"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "coral",
              "6"
            ]
          },
          "7": {
            "value": "#801f0f",
            "dark": "#872012",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#801f0f",
              "dark": "#872012"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "coral",
              "7"
            ]
          },
          "8": {
            "value": "#691105",
            "dark": "#640d04",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#691105",
              "dark": "#640d04"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "coral",
              "8"
            ]
          },
          "9": {
            "value": "#510901",
            "dark": "#460701",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#510901",
              "dark": "#460701"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "coral",
              "9"
            ]
          }
        },
        "lemon": {
          "0": {
            "value": "#FDF5B3",
            "dark": "#FFF6A6",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#FDF5B3",
              "dark": "#FFF6A6"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lemon",
              "0"
            ]
          },
          "1": {
            "value": "#F4E162",
            "dark": "#FAE85A",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#F4E162",
              "dark": "#FAE85A"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lemon",
              "1"
            ]
          },
          "2": {
            "value": "#DEC741",
            "dark": "#E1CD41",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#DEC741",
              "dark": "#E1CD41"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lemon",
              "2"
            ]
          },
          "3": {
            "value": "#C5AA20",
            "dark": "#C5AE13",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#C5AA20",
              "dark": "#C5AE13"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lemon",
              "3"
            ]
          },
          "4": {
            "value": "#A88D02",
            "dark": "#A69000",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#A88D02",
              "dark": "#A69000"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lemon",
              "4"
            ]
          },
          "5": {
            "value": "#866D00",
            "dark": "#8C7600",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#866D00",
              "dark": "#8C7600"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lemon",
              "5"
            ]
          },
          "6": {
            "value": "#685400",
            "dark": "#705D00",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#685400",
              "dark": "#705D00"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lemon",
              "6"
            ]
          },
          "7": {
            "value": "#534100",
            "dark": "#564500",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#534100",
              "dark": "#564500"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lemon",
              "7"
            ]
          },
          "8": {
            "value": "#413200",
            "dark": "#3D2F00",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#413200",
              "dark": "#3D2F00"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lemon",
              "8"
            ]
          },
          "9": {
            "value": "#322400",
            "dark": "#2A1E00",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#322400",
              "dark": "#2A1E00"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lemon",
              "9"
            ]
          }
        },
        "lime": {
          "0": {
            "value": "#EAFABA",
            "dark": "#D9EF95",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#EAFABA",
              "dark": "#D9EF95"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lime",
              "0"
            ]
          },
          "1": {
            "value": "#CDEC78",
            "dark": "#BEDC6C",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#CDEC78",
              "dark": "#BEDC6C"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lime",
              "1"
            ]
          },
          "2": {
            "value": "#B1D353",
            "dark": "#A4C847",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#B1D353",
              "dark": "#A4C847"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lime",
              "2"
            ]
          },
          "3": {
            "value": "#94B83B",
            "dark": "#8AB034",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#94B83B",
              "dark": "#8AB034"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lime",
              "3"
            ]
          },
          "4": {
            "value": "#799A2A",
            "dark": "#739826",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#799A2A",
              "dark": "#739826"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lime",
              "4"
            ]
          },
          "5": {
            "value": "#5A791B",
            "dark": "#5C8118",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#5A791B",
              "dark": "#5C8118"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lime",
              "5"
            ]
          },
          "6": {
            "value": "#425E13",
            "dark": "#46680F",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#425E13",
              "dark": "#46680F"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lime",
              "6"
            ]
          },
          "7": {
            "value": "#2F4A06",
            "dark": "#314F07",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#2F4A06",
              "dark": "#314F07"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lime",
              "7"
            ]
          },
          "8": {
            "value": "#233B03",
            "dark": "#1E3703",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#233B03",
              "dark": "#1E3703"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lime",
              "8"
            ]
          },
          "9": {
            "value": "#182C01",
            "dark": "#102401",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#182C01",
              "dark": "#102401"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lime",
              "9"
            ]
          }
        },
        "teal": {
          "0": {
            "value": "#DAF9F5",
            "dark": "#BDEEE8",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#DAF9F5",
              "dark": "#BDEEE8"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "teal",
              "0"
            ]
          },
          "1": {
            "value": "#B0EAE3",
            "dark": "#8ADFD7",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#B0EAE3",
              "dark": "#8ADFD7"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "teal",
              "1"
            ]
          },
          "2": {
            "value": "#6BD6D0",
            "dark": "#57CCC5",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#6BD6D0",
              "dark": "#57CCC5"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "teal",
              "2"
            ]
          },
          "3": {
            "value": "#49BCB7",
            "dark": "#33B3AE",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#49BCB7",
              "dark": "#33B3AE"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "teal",
              "3"
            ]
          },
          "4": {
            "value": "#339D9B",
            "dark": "#2A9D9A",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#339D9B",
              "dark": "#2A9D9A"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "teal",
              "4"
            ]
          },
          "5": {
            "value": "#197B7B",
            "dark": "#1D8281",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#197B7B",
              "dark": "#1D8281"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "teal",
              "5"
            ]
          },
          "6": {
            "value": "#136061",
            "dark": "#14696A",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#136061",
              "dark": "#14696A"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "teal",
              "6"
            ]
          },
          "7": {
            "value": "#024B4D",
            "dark": "#0B5051",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#024B4D",
              "dark": "#0B5051"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "teal",
              "7"
            ]
          },
          "8": {
            "value": "#063A3C",
            "dark": "#053738",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#063A3C",
              "dark": "#053738"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "teal",
              "8"
            ]
          },
          "9": {
            "value": "#052B2C",
            "dark": "#022425",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#052B2C",
              "dark": "#022425"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "teal",
              "9"
            ]
          }
        },
        "indigo": {
          "0": {
            "value": "#EFF2FF",
            "dark": "#DBE3FF",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#EFF2FF",
              "dark": "#DBE3FF"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "indigo",
              "0"
            ]
          },
          "1": {
            "value": "#D7DDFF",
            "dark": "#C5CFFF",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#D7DDFF",
              "dark": "#C5CFFF"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "indigo",
              "1"
            ]
          },
          "2": {
            "value": "#B9C2FF",
            "dark": "#ABB4FF",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#B9C2FF",
              "dark": "#ABB4FF"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "indigo",
              "2"
            ]
          },
          "3": {
            "value": "#9AA4FF",
            "dark": "#939AFF",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#9AA4FF",
              "dark": "#939AFF"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "indigo",
              "3"
            ]
          },
          "4": {
            "value": "#7683FF",
            "dark": "#797EF9",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#7683FF",
              "dark": "#797EF9"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "indigo",
              "4"
            ]
          },
          "5": {
            "value": "#545DF0",
            "dark": "#5D63F0",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#545DF0",
              "dark": "#5D63F0"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "indigo",
              "5"
            ]
          },
          "6": {
            "value": "#3C42D0",
            "dark": "#464ED1",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#3C42D0",
              "dark": "#464ED1"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "indigo",
              "6"
            ]
          },
          "7": {
            "value": "#2C33A5",
            "dark": "#3238A7",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#2C33A5",
              "dark": "#3238A7"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "indigo",
              "7"
            ]
          },
          "8": {
            "value": "#22297F",
            "dark": "#1E267C",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#22297F",
              "dark": "#1E267C"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "indigo",
              "8"
            ]
          },
          "9": {
            "value": "#191F5C",
            "dark": "#131759",
            "filePath": "tokens/base/colors/light.json",
            "isSource": true,
            "original": {
              "value": "#191F5C",
              "dark": "#131759"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "indigo",
              "9"
            ]
          }
        }
      }
    }
  }
};
